import React from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { Form, Input, Button, Icon, Spin, notification } from 'antd';
import { loginUser, resetLoading } from '../../actions/LoginActions';
import { RoutePath } from '../../constants/SitePaths';
import { Auth } from '../../services/Auth';
import { LocalStorageService } from '../../services/LocalStorageService';
import { injectIntl, FormattedMessage } from 'react-intl';
import RegularExpression from '../../constants/RegularExpression';
import {isLocalhost, RE_CAPTCHA_KEY} from "../../constants/Configs";
import ReCAPTCHA from 'react-google-recaptcha';

const FormItem = Form.Item;

/**
 * Enum for Checking user type.
 * @readonly
 * @enum {number}
 */

export const userTypeEnum = {
    /** Users in Main Affiliate site */
    MainPartner: 1,
    /** Users in SubAffiliate site */
    SubPartner: 2
}

class LoginForm extends React.Component {

    state = {
        redirect: false,
        captchaCode: "",
        showCaptcha: true
    }

    // /**
    //  * Handles Google reCaptcha's callback
    //  * @function
    //  * @memberOf LoginForm
    //  * @param {Object} response
    //  * @public
    //  */
    reCaptchaCallback = (response) => {
        this.setState({ captchaCode: response });
    }

    // /**
    //  * Fires when Google reCaptcha expires
    //  * @function
    //  * @memberOf LoginForm
    //  * @param {Object} response
    //  * @public
    //  */
    onCaptchaExpired = () => {
        this.setState({ captchaCode: "" })
    }

    componentDidMount() {
        const hideCapthca = isLocalhost || !window.location.hostname.includes('tst.webaffiliates.net') || !window.location.hostname.includes('webaffiliates.stgdigitain.com');
        this.setState({showCaptcha: !hideCapthca});
        if (!hideCapthca) {
            window.recaptchaOptions = {
                lang: this.props.locale
            }
        }
    }

    componentWillMount() {
        //Reset initial state
        LocalStorageService.remove("saved_store_state");
        this.props.resetLoading();
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { userType } = this.props.user;
        const { permissions } = this.props.affiliates;

        const antIcon = <Icon type="loading" className="ta--ant_loader" spin />;

        // Used Async redirect for Particles fast redirect issue(ctx is undefined problem)
        if (Auth.isAuthenticated()) {
            this.setState({ redirect: true });
        }

        if (this.state.redirect && Auth.isAuthenticated()) {
            return <Redirect to={parseInt(userType, 10) === userTypeEnum.MainPartner
                ? RoutePath.AFFILIATES
                : permissions && permissions.includes('Reports')
                    ? RoutePath.REPORTS
                    : RoutePath.WITHDRAW
            } />;
        }

        const captchaTemplate = this.state.showCaptcha ?
            <FormItem
                extra={!this.state.captchaCode ? this.props.intl.messages.human : ''}
                validateStatus={!this.state.captchaCode ? 'error' : 'success'}
                className='ta--login-captcha ta--f-12'
            >
                <ReCAPTCHA
                    ref="recaptcha"
                    sitekey={RE_CAPTCHA_KEY}
                    onChange={this.reCaptchaCallback}
                    onExpired={this.onCaptchaExpired}
                />
            </FormItem> : ''; // TODO

        return (
            <Spin indicator={antIcon} spinning={this.props.user.inProcess} >
                <div className="ta--login-form">
                    <div className='ta--form-title ta--mb-16 rtl--text-right'>{this.props.intl.messages.sign_in}</div>
                    <Form onSubmit={this.handleSubmit}>
                        <FormItem label={this.props.intl.messages.email}>
                            {getFieldDecorator('username', {
                                rules: [
                                    { required: true, message: this.props.intl.messages.email_required },
                                    { pattern: RegularExpression.EMAIL_VALIDATION, message: this.props.intl.messages.email_required }
                                ],
                            })(
                                <Input placeholder={this.props.intl.messages.type_your_email} />
                            )}
                        </FormItem>
                        <FormItem label={this.props.intl.messages.password}>
                            {getFieldDecorator('password', {
                                rules: [
                                    { required: true, message: this.props.intl.messages.password_required }
                                ],
                            })(
                                <Input type="password" placeholder={this.props.intl.messages.type_your_password} />
                            )}
                        </FormItem>

                        { captchaTemplate }

                        <FormItem className='ta--login-footer'>
                            <div className='ta--login-footer_txts'>
                                <Link to={"registration"}><FormattedMessage id="sign_up" /></Link> | <Link to={"forgot-password"}><FormattedMessage id="forgot_password" /></Link>
                            </div>
                            <div className='ta--login-footer_btn'>
                                <Button loading={this.props.user.isLoading} type="primary" htmlType="submit" className="button" onClick={this.props.handleSubmit.bind(this, this.props.form, this.props, this.state)}>
                                    <FormattedMessage id="sign_in" />
                                </Button>
                            </div>
                        </FormItem>
                    </Form>
                </div>
            </Spin>
        );
    }
}

const Login = Form.create()(LoginForm);

const mapDispatchToProps = (dispatch, props) => {
    return ({
        resetLoading: () => {
            dispatch(resetLoading());
        },
        handleSubmit: (form, props, state) => {
            if (state.showCaptcha && !state.captchaCode) {
                notification.error({
                    key: 'registrationError',
                    placement: 'bottomRight',
                    duration: 5,
                    message: props.intl.messages.human
                });
                return;
            }
            //Validate completed data
            form.validateFields((err, values) => {
                if (!err) {
                    values.captchaCode = state.captchaCode;
                    dispatch(loginUser(values, props.history));
                }
            });
        },
        dispatch
    })
}

const mapStateToProps = state => {
    return {
        user: state.user,
        affiliates: state.affiliates,
        verification: state.verification
    }
}

export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(Login));


// WEBPACK FOOTER //
// ./src/routes/account/Login.js